import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {PivotGridData} from "./pivot-grid.data";

@Injectable()
export class PivotGridEntityModel extends EntityModel<PivotGridData> {
    constructor(injector: Injector) {
        super(injector, PivotGridData);
    }

    override getResourceName(): string {
        return "bi-pivot-grid";
    }
}
